import React, { createContext, useContext, useState, ReactNode } from 'react';
import { MAPPStatus } from 'components/MappCodeCard/types';

interface ProductContextType {
  productCode: string;
  setProductCode: (code: string) => void;
  tempProductCode: string;
  setTempProductCode: (code: string) => void;
  mappStatus: MAPPStatus | null;
  setMappStatus: (status: MAPPStatus | null) => void;
}

const ProductContext = createContext<ProductContextType | undefined>(undefined);

export const ProductProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [productCode, setProductCode] = useState<string>('');
  const [tempProductCode, setTempProductCode] = useState<string>('');
  const [mappStatus, setMappStatus] = useState<MAPPStatus | null>(null);

  return (
    <ProductContext.Provider
      value={{
        productCode,
        setProductCode,
        tempProductCode,
        setTempProductCode,
        mappStatus,
        setMappStatus,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export const useProduct = () => {
  const context = useContext(ProductContext);
  if (context === undefined) {
    throw new Error('useProduct must be used within a ProductProvider');
  }
  return context;
}; 